/* unplugin-vue-components disabled */import { render } from "./Banners.vue?vue&type=template&id=0d377af4"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__